import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, message, Image } from "antd";
import { formateDate } from "../../utils/dateUtil";
import {
  req_single_people_public,
  req_config_gsm_gate_status_public,
  req_add_gsm_singer_enrolment_public,
} from "../../api";
import queryString from "query-string";
import "./signer-enrolment-open.css";

const { Search } = Input;
class SignerEnrolmentOpen extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    staff: {
      Cellphone: "",
      DepartmentTwName: "",
      Code: "NONE",
      TwId: "",
      TwName: "",
    },
    item: {
      StaffType: "masses",
      SchoolGateLocation: "NONE",
      DepartmentMainName: "",
      StaffCode: "",
      StaffName: "",
      SignUserCode: "",
      SignStatus: "",
    },
    items: [],
    picUrl: "",
    identity: "student",
    gateStatus: "OFF",
    gateLocation: "NONE",
    signStatus: "IN",
    isDisabled: false,
  };
  UNSAFE_componentWillMount() {
    const parsed = queryString.parse(window.location.search);
    const { type } = parsed;
    if (type) {
      // 取得個人部落格 取不到則公版資訊
      //console.log(type);
      this.api_gate_status(type.slice(0, 5));
      switch (type) {
        case "GATEAIN":
          this.setState({
            gateLocation: type.slice(0, 5),
            signStatus: type.slice(5, 7),
          });
          break;
        case "GATEBIN":
          this.setState({
            gateLocation: type.slice(0, 5),
            signStatus: type.slice(5, 7),
          });
          break;
        case "GATEAOUT":
          this.setState({
            gateLocation: type.slice(0, 5),
            signStatus: type.slice(5, 8),
          });
          break;
        case "GATEBAOUT":
          this.setState({
            gateLocation: type.slice(0, 5),
            signStatus: type.slice(5, 8),
          });
          break;
        default:
          break;
      }
      // console.log("slice(0, 5):", type.slice(0, 5));
      // console.log("slice(5, 8):", type.slice(5, 8));
    } else {
    }
  }

  api_gate_status = async (userLevel) => {
    const result = await req_config_gsm_gate_status_public(userLevel);
    if (result.total > 0) {
      const item = result.data[0];
      const { GateStatus } = item;
      this.setState({ gateStatus: GateStatus, isDisabled: true });
      if (GateStatus === "OFF") {
        this.setState({ isDisabled: true });
        message.error("未開放登記!!");
      } else {
        this.setState({ isDisabled: false });
      }
    }
  };

  api_check_data = async (userCode) => {
    const result = await req_single_people_public(userCode);
    const identity = userCode.length < 7 ? "teacher" : "student";
    // console.log("result", result);
    if (result.Code === "NONE") {
      message.info("查無此人");
    } else {
      this.disableButton();
      const { signStatus, gateLocation } = this.state;
      const row = {
        StaffType: identity,
        SchoolGateLocation: gateLocation,
        DepartmentMainName: result.DepartmentTwName,
        StaffCode: result.TwId,
        StaffName: result.TwName,
        SignUserCode: userCode,
        StaffCellphone: result.Cellphone,
        SignDescription: "",
        SignStatus: signStatus,
      };
      this.api_add_item(row);
      const picUrl =
        userCode.length < 7
          ? "https://rm.tut.edu.tw/ab/DisplaySmallPicture.ashx?p=pic/" +
            userCode +
            ".jpg&w=80&h=100"
          : "https://stu95.tut.edu.tw/SC2008/PHOTO/" + userCode + ".jpg";

      this.setState({ picUrl, identity, staff: result });
      //console.log(picUrl);
    }
  };

  api_add_item = async (item) => {
    const result = await req_add_gsm_singer_enrolment_public(item);
    if (result.status === "success") {
      // message.success("登記成功");
    } else {
      ///  message.error("登記失敗");
    }
  };

  onSearch = (value) => {
    //console.log(value);
    if (value.length > 0 && value.trim().length < 15) {
      const inputdata = value.trim().toUpperCase();
      var role = new RegExp();
      role = /^[A-Za-z0-9]+$/;
      if (!role.test(inputdata)) {
        message.info("請輸入正確學(職)號");
      } else {
        this.api_check_data(inputdata);
      }
    } else {
      message.info("請輸入正確學(職)號");
    }
  };

  disableButton = () => {
    this.setState({ isDisabled: true }, () =>
      setTimeout(() => {
        const staff = {
          Cellphone: "",
          DepartmentTwName: "",
          Code: "NONE",
          TwId: "",
          TwName: "",
        };

        this.setState({ isDisabled: false, staff });
      }, 30000)
    );
  };

  render() {
    const { staff, picUrl, gateLocation, signStatus } = this.state;
    const { Code } = staff;
    const info = (
      <>
        {Code === "NONE" ? (
          ""
        ) : (
          <>
            <div
              style={{
                fontSize: "1.5em",
                textAlign: "center",
                width: "200px",
                border: "1px solid white",
                margin: "15px auto",
                padding: "5px",
                borderRadius: "5px",
                backgroundColor: "#26004d",
              }}
            >
              <div>
                <Image width={80} src={picUrl} />
              </div>
              <div>{staff.TwName}</div>
              <div>{gateLocation === "GATEA" ? "第一校門" : "第二校門"}</div>
              <div>{formateDate(new Date())}</div>
              <div>{signStatus === "IN" ? "入校" : "離校"}登記成功</div>
            </div>
          </>
        )}
      </>
    );
    return (
      <div id="block">
        <div className="sign">
          <div style={{ fontSize: "1.5em", textAlign: "center" }}>
            夜間入校登記系統
          </div>
          <div>
            {" "}
            <Search
              placeholder="請輸入學(職)號"
              allowClear
              enterButton="登記"
              size="large"
              onSearch={this.onSearch}
              disabled={this.state.isDisabled}
            />
          </div>
          <div style={{ width: "100%" }}>{info}</div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SignerEnrolmentOpen);
